export const settingsHubPtBr = {
  title: 'Configurações',
  searchModules: 'Buscar módulo',
  searchSettings: 'Buscar em configurações',
  modulesLabel: 'Módulos',
  navigationLabel: 'Navegação',
  backToApp: 'Voltar ao aplicativo',
  showNavigation: 'Navegação',
  placeholder: {
    title: 'Em breve',
    description: 'Esta configuração ainda será disponibilizada no hub centralizado.',
  },
  accessDenied: {
    title: 'Acesso negado',
    description: 'Você não tem permissão para acessar esta configuração.',
  },
  modules: {
    general: 'Geral',
    organization: 'Organização',
    accountingFiscal: 'Contábil & Fiscal',
    accountsPayable: 'Contas a Pagar',
    accountsReceivable: 'Contas a Receber',
    procurement: 'Compras',
    budget: 'Orçamento',
    usersPermissions: 'Usuários & Permissões',
    integrations: 'Integrações',
    hcm: 'Pessoas',
  },
  submodules: {
    entities: 'Entidades',
    chartOfAccounts: 'Plano de contas',
    managerialChartOfAccounts: 'Plano de contas gerencial',
    accountMapping: 'Mapeamento de contas',
    statutoryTreatment: 'Tratamento de guias',
    revenueTaxRules: 'Tributos sobre receita',
    books: 'Livros',
    calendars: 'Calendários',
    periods: 'Períodos',
    globalSettings: 'Contexto organização',
    themes: 'Temas',
    preferences: 'Preferências',
    apGeneralSettings: 'Geral',
    approvalSettings: 'Aprovações',
    classificationRules: 'Classificações',
    departments: 'Departamentos',
    costCenters: 'Centros de custo',
    customFields: 'Campos customizados',
    otherSettings: 'Outras configurações',
    reimbursementSettings: 'Reembolsos - Políticas',
    reimbursementCategories: 'Reembolsos - Categorias',
    reimbursements: 'Reembolsos',
    procurementSettings: 'Configurações',
    arCollectionSettings: 'Cobrança',
    arInvoiceApprovalSettings: 'Aprovação de faturas',
    billingArForecastSettings: 'Previsão AR (uso)',
    integrationsCatalog: 'Catálogo',
    dimensionReconciliation: 'Mapeamentos',
    integrationsManage: 'Gerenciamento',
    connectedAgents: 'Agentes conectados',
    users: 'Usuários',
    roles: 'Papéis',
    invitations: 'Convites',
    myAccount: 'Minha conta',
    payrollSettings: 'Folha de pagamento',
    payrollGlMapping: 'Contabilização da folha',
  },
  entities: {
    description: 'Gerencie as empresas e filiais vinculadas ao ambiente fiscal e contábil.',
    newEntity: 'Nova entidade',
    columns: {
      legalName: 'Razão social',
      cnpj: 'CNPJ',
      taxRegime: 'Regime tributário',
      type: 'Tipo',
      status: 'Status',
      actions: 'Ações',
    },
    types: {
      headquarters: 'Matriz',
      branch: 'Filial',
    },
    status: {
      active: 'Ativo',
      inactive: 'Inativo',
    },
    preferences: {
      title: 'Preferências de entidades',
      syncReceita: 'Sincronizar automaticamente com a Receita Federal',
      syncReceitaDescription:
        'Atualiza dados cadastrais das entidades com base nas consultas oficiais.',
      requireApproval: 'Exigir aprovação para criação de novas entidades',
      requireApprovalDescription:
        'Novas entidades passam por fluxo de aprovação antes de ficarem ativas.',
      defaultCurrency: 'Moeda padrão',
      defaultCurrencyDescription: 'Moeda usada como padrão para novas entidades.',
      currencyBrl: 'BRL – Real brasileiro',
    },
  },
};

export const settingsHubEn = {
  title: 'Settings',
  searchModules: 'Search module',
  searchSettings: 'Search settings',
  modulesLabel: 'Modules',
  navigationLabel: 'Navigation',
  backToApp: 'Back to app',
  showNavigation: 'Navigation',
  placeholder: {
    title: 'Coming soon',
    description: 'This setting will be available in the centralized hub soon.',
  },
  accessDenied: {
    title: 'Access denied',
    description: 'You do not have permission to access this setting.',
  },
  modules: {
    general: 'General',
    organization: 'Organization',
    accountingFiscal: 'Accounting & Tax',
    accountsPayable: 'Accounts Payable',
    accountsReceivable: 'Accounts Receivable',
    procurement: 'Procurement',
    budget: 'Budget',
    usersPermissions: 'Users & Permissions',
    integrations: 'Integrations',
    hcm: 'People',
  },
  submodules: {
    entities: 'Entities',
    chartOfAccounts: 'Chart of accounts',
    managerialChartOfAccounts: 'Managerial chart of accounts',
    accountMapping: 'Account mapping',
    statutoryTreatment: 'Tax slip treatment',
    revenueTaxRules: 'Revenue taxes',
    books: 'Books',
    calendars: 'Calendars',
    periods: 'Periods',
    globalSettings: 'Organization context',
    themes: 'Themes',
    preferences: 'Preferences',
    apGeneralSettings: 'General',
    approvalSettings: 'Approvals',
    classificationRules: 'Classification rules',
    departments: 'Departments',
    costCenters: 'Cost centers',
    customFields: 'Custom fields',
    otherSettings: 'Other settings',
    reimbursementSettings: 'Reimbursements - Policies',
    reimbursementCategories: 'Reimbursements - Categories',
    reimbursements: 'Reimbursements',
    procurementSettings: 'Settings',
    arCollectionSettings: 'Collections',
    arInvoiceApprovalSettings: 'Invoice approval',
    billingArForecastSettings: 'AR forecast (usage)',
    integrationsCatalog: 'Catalog',
    dimensionReconciliation: 'Mappings',
    integrationsManage: 'Management',
    connectedAgents: 'Connected agents',
    users: 'Users',
    roles: 'Roles',
    invitations: 'Invitations',
    myAccount: 'My account',
    payrollSettings: 'Payroll',
    payrollGlMapping: 'Payroll accounting',
  },
  entities: {
    description: 'Manage companies and branches linked to the tax and accounting environment.',
    newEntity: 'New entity',
    columns: {
      legalName: 'Legal name',
      cnpj: 'CNPJ',
      taxRegime: 'Tax regime',
      type: 'Type',
      status: 'Status',
      actions: 'Actions',
    },
    types: {
      headquarters: 'Headquarters',
      branch: 'Branch',
    },
    status: {
      active: 'Active',
      inactive: 'Inactive',
    },
    preferences: {
      title: 'Entity preferences',
      syncReceita: 'Automatically sync with Federal Revenue',
      syncReceitaDescription: 'Updates entity registration data from official lookups.',
      requireApproval: 'Require approval for new entities',
      requireApprovalDescription: 'New entities go through approval before becoming active.',
      defaultCurrency: 'Default currency',
      defaultCurrencyDescription: 'Currency used as default for new entities.',
      currencyBrl: 'BRL – Brazilian Real',
    },
  },
};
